import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { BindCssVariableModule } from '../../directives/bind-css-variable.directive';

@Component({
  selector: 'lp2-checkbox-with-hover-point',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .checkbox {
        background-color: transparent;
        color: white;
        width: 18px;
        height: 18px;
        border: 1px solid white;
        border-radius: 4px;
      }

      .fa-icon {
        font-size: 10px;
      }

      .hover-circle {
        display: none;
      }

      .hover-circle {
        display: block;
        height: 50%;
        width: 50%;
        border-radius: 100%;
        background-color: var(--colorVar);
      }

      .checkbox-checked {
        background-color: var(--colorVar);
        border: none;
      }
    `,
  ],
  template: `
    <div
      class="checkbox d-flex align-items-center justify-content-center mt-1 mr-3"
      role="checkbox"
      [ngClass]="{ 'checkbox-checked': checked }"
      [bindCssVariable]="{ colorVar: color }"
      (click)="onChange()"
    >
      <div *ngIf="!checked && hovered" class="hover-circle"></div>
      <i *ngIf="checked" class="fa-icon far fa-check"></i>
    </div>
  `,
})
export class CheckboxWithHoverPointComponent {
  @Input() checked = false;
  @Input() hovered = false;
  @Input() color: string = null;
  @Output() change = new EventEmitter();

  public onChange() {
    this.change.emit();
  }
}

@NgModule({
  imports: [CommonModule, BindCssVariableModule],
  declarations: [CheckboxWithHoverPointComponent],
  exports: [CheckboxWithHoverPointComponent],
})
export class CheckboxWithHoverPointModule {}



// WEBPACK FOOTER //
// ./ts/app/components/checkbox-with-hover-point/checkbox-with-hover-point.component.ts